var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-box pointer",on:{"click":_vm.startUsingHandle}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }